import { render } from "./LuxuryTravel02.vue?vue&type=template&id=4f658de8&scoped=true"
import script from "./LuxuryTravel02.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel02.vue?vue&type=script&lang=js"

import "./LuxuryTravel02.scss?vue&type=style&index=0&id=4f658de8&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f658de8"]])

export default __exports__